import { useState, useEffect } from 'react'
import { Logo } from './Logo'
import { Sparkles, Menu, X, ArrowRight } from 'lucide-react'
const Navbar = ({ onOpenDemoModal }) => {
  const [scrolled, setScrolled] = useState(false)
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])
  const navLinks = [
    { name: 'Agentes de IA', href: '#agentes' },
    { name: 'Oficina Virtual', href: '#oficina-virtual' },
    { name: 'Precios', href: '#precios' },
    { name: 'Lanzadera', href: '#lanzadera' },
  ]
  const handleNavClick = (e, href) => {
    e.preventDefault()
    setMobileMenuOpen(false)
    const target = document.querySelector(href)
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' })
    }
  }
  const handleCtaClick = () => {
    setMobileMenuOpen(false)
    if (onOpenDemoModal) {
      onOpenDemoModal()
    } else {
      const formEl = document.getElementById('demo-form')
      if (formEl) {
        formEl.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }
  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-[#011e1b]/85 backdrop-blur-xl border-b border-[#00FF9D]/15 shadow-[0_10px_30px_rgba(0,0,0,0.5)] py-3'
          : 'bg-transparent border-b border-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between">
        {/* Brand */}
        <a
          href="#"
          className="flex items-center gap-3 group focus:outline-none"
        >
          <Logo size="md" glow={true} />
          <span className="hidden sm:inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium bg-[#05332E] text-[#00FF9D] border border-[#00FF9D]/20">
            <span className="w-1.5 h-1.5 rounded-full bg-[#00FF9D] animate-ping" />
            v2.4 Live
          </span>
        </a>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-1 bg-[#05332E]/70 border border-[#00FF9D]/15 backdrop-blur-md px-4 py-1.5 rounded-full">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              onClick={(e) => handleNavClick(e, link.href)}
              className="px-4 py-2 text-sm font-medium text-[#CBD5E1] hover:text-[#00FF9D] transition-colors rounded-full hover:bg-[#0A3F39]/60"
            >
              {link.name}
            </a>
          ))}
        </nav>

        {/* Action Button */}
        <div className="hidden md:flex items-center gap-4">
          <button
            onClick={handleCtaClick}
            id="nav-cta-button"
            className="group relative inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#00FF9D] hover:bg-[#00E676] text-[#012622] font-semibold text-sm transition-all duration-200 shadow-[0_0_20px_rgba(0,255,157,0.35)] hover:shadow-[0_0_28px_rgba(0,255,157,0.55)] active:scale-95 cursor-pointer"
          >
            <span>Solicitar Demo</span>
            <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
          </button>
        </div>

        {/* Mobile menu button */}
        <div className="flex md:hidden items-center gap-2">
          <button
            onClick={handleCtaClick}
            className="px-3 py-1.5 text-xs font-semibold rounded-full bg-[#00FF9D] text-[#012622]"
          >
            Demo
          </button>
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="p-2 rounded-lg bg-[#05332E] text-[#CBD5E1] hover:text-white border border-[#00FF9D]/20 focus:outline-none"
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? (
              <X className="w-5 h-5" />
            ) : (
              <Menu className="w-5 h-5" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile dropdown */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-[#031E1B] border-b border-[#00FF9D]/20 px-4 pt-3 pb-6 mt-2 space-y-3 shadow-2xl animate-in slide-in-from-top-2">
          <div className="flex flex-col space-y-1">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                onClick={(e) => handleNavClick(e, link.href)}
                className="px-4 py-3 rounded-lg text-base font-medium text-white hover:bg-[#05332E] hover:text-[#00FF9D] transition-colors"
              >
                {link.name}
              </a>
            ))}
          </div>
          <div className="pt-2 border-t border-[#05332E]">
            <button
              onClick={handleCtaClick}
              className="w-full flex items-center justify-center gap-2 px-5 py-3 rounded-xl bg-[#00FF9D] text-[#012622] font-bold text-sm shadow-[0_0_20px_rgba(0,255,157,0.4)]"
            >
              <Sparkles className="w-4 h-4" />
              Solicitar Demo Personalizada
            </button>
          </div>
        </div>
      )}
    </header>
  )
}
export { Navbar }
